import { render, staticRenderFns } from "./RequestCanceled.vue?vue&type=template&id=85d398aa"
import script from "./RequestCanceled.vue?vue&type=script&lang=js"
export * from "./RequestCanceled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports